export default __webpack_public_path__ + "static/media/arrow-down.41c668b2.svg";